$bog_music_app $mol_page
	plugins /
		<= Skin $bog_builderui_skin
			lights <= lights
			base \zinc
			font_head \eb-garamond
		<= Theme $bog_theme_auto
		<= Popup_fix $bog_popup_plugin
		<= Tooltip $bog_tooltip_plugin
	lights \system
	font_size? \normal
	attr *
		^
		bog_music_font <= font_size
	title \Bog Music
	Title <= Brand $mol_view
		sub /
			<= Brand_image $mol_image
				uri \bog/music/app/favicon.svg
				title <= title
			<= Brand_name $mol_view
				sub / <= title
	tools /
		<= Sync_status $giper_baza_status
		<= Nickname_label $mol_view
			sub / <= nickname_label \
		<= Version $mol_view
			sub / <= version_label \
		<= Wave_toggle $mol_check_icon
			hint \Моя волна
			Icon <= Wave_icon $mol_icon_chart_timeline_variant
			checked? <=> wave_mode? false
		<= Upload $mol_button_open
			hint \Загрузить с устройства
			accept \audio/*,.mp3,.m4a,.aac,.wav,.ogg,.flac
			files? <=> upload_files? /File
		<= Theme_btn $bog_theme_toggle
			theme_auto <= Theme
	body_scroll_top? <=> scroll? 0
	body /
		<= Account $bog_music_account
			font_size? <=> font_size?
			dev? <=> dev? false
			download_playlist? <=> download_playlist? null
			download_playlist_status <= download_playlist_status \
			tg_hint <= tg_hint \
			tg_button <= tg_button \
			tg_status <= tg_status \
			tg_link? <=> tg_link? null
			fm_hint <= fm_hint \
			fm_button <= fm_button \
			fm_status <= fm_status \
			fm_link? <=> fm_link? null
		<= Logs $bog_music_log_view
			version <= version_label
		<= Feedback $bog_feedback2_form
			feedback_id \bog_music
		<= Share_toast $mol_view
			sub / <= share_toast_text \
		<= Beam_bar $mol_view
			sub /
				<= Beam_text $mol_view
					sub / <= beam_text \
				<= Beam_pull $mol_button_minor
					title <= beam_button \
					click? <=> beam_pull? null
		<= Tabs $bog_music_playlists
			page? <=> page? \my
			my_title <= my_title \Моя музыка
			archive_title <= archive_title \Архив
			list_dict <= list_dict *
		<= Tracks $bog_music_tracks
			track_keys <= visible_keys /
			current_key <= current_key \
			play_key? <=> play_key? null
			archive_mode <= archive_mode false
			reorder_to? <=> reorder_to? null
			archive_key? <=> archive_key? null
			restore_key? <=> restore_key? null
			delete_key? <=> delete_key? null
			demote_key? <=> demote_key? null
		<= Tube_bar $mol_view
			dom_name \form
			event *
				^
				submit?event <=> tube_submit?event null
			sub /
				<= Tube_query $mol_string
					hint \Что ищем на YouTube?
					value? <=> tube_query? \
					keyboard \search
					enter \search
				<= Tube_find $mol_button_major
					title \Найти
					click? <=> tube_find? null
		<= Tube_list $mol_list
			rows <= tube_rows /
		<= Tube_row* $bog_music_tube_row
			title <= tube_title* \
			subtitle <= tube_meta* \
			status <= tube_status_text* \
			cover <= tube_cover* \
			busy <= tube_busy* false
			play? <=> tube_play*? null
			get? <=> tube_get*? null
	foot /
		<= Player $bog_music_player
			full <= player_full false
			open?event <=> player_open?event null
			collapse?event <=> player_collapse?event null
			queue_keys <= visible_keys /
			current_key? <=> current_key? \
		<= Nav $bog_music_nav
			section? <=> section? \music
			dev <= dev?
